import * as d3 from 'd3'
import * as flubber from 'flubber'
import Chart from '../chart'

import './WorldMap.css'

import * as classicalWorld from './classicalWorld.json';
import * as squaredWorld from './gridWorld.json';

export default class WorldMap extends Chart {
  create() {
    this.world = classicalWorld;
    this.worldTile = squaredWorld;
    
    this.svg = super.createRoot();

    this.main = this.svg.append('g')
      .attr('class', 'main')
      .attr('transform', `translate(${this.props.margin.left},${this.props.margin.top})`);
    
    this.legend = this.svg.append('g')
      .attr('class', 'ledgend')
      .attr('transform', `translate(${this.props.margin.left + 20},${this.props.height - this.props.margin.bottom - 50})`);
    
    this.map = this.main.append('g')
      .attr('class', 'map');
    
    this.labels = this.main.append('g')
      .attr('class', 'labels');
    
    this.tooltip = d3.select('body')
      .append('div')
      .attr('class', 'world-map-tooltip')
  }
  update(state) {
    this.valueAccessor = state.valueAccessor;
    this.countryCodeType = state.countryCodeType;
    this.countryCodeAccessor = state.countryCodeAccessor;
    if(state.data && JSON.stringify(this.data) !== JSON.stringify(state.data)) {
      this._drawMap(state.data);
    }
    if(state.view && this.view !== state.view){
      if(state.view === 'classic'){
        this.switchToClassic();
      } else {
        this.switchToSquares();
      }
    }
    this.data = state.data;
    this.view = state.view;
    return this.svg.node();
  }
  _drawMap(data) { 
    //const dataDomain = d3.extent(data, d => d[this.valueAccessor]);
    const dataMapping = data.reduce( (agg, v) => {
      var country; 
      if(this.countryCodeType === 'name'){
        country = this.worldTile.find( d => d.name === v[this.countryCodeAccessor])
      }
      if(country) agg[country.alpha2] = v[this.valueAccessor];
      return agg;
    }, {});
    // create a first guess for the projection
    var projection = d3.geoNaturalEarth1()
      .scale(1)
      .translate([0, 0]);
    // create the path
    var path = d3.geoPath()
      .projection(projection);
    // using the path determine the bounds of the current map and use 
    // these to determine better values for the scale and translation
    var bounds = path.bounds(this.world);
    var scale = .95 / Math.max(
      (bounds[1][0] - bounds[0][0]) / this.props.width, 
      (bounds[1][1] - bounds[0][1]) / this.props.height
    );
    const numberOfColors = 8
    const scheme = d3.schemeRdPu[numberOfColors]
    //const colorScale = d3.scaleQuantize(dataDomain, scheme)
    /*const values = data.map(d => d[this.valueAccessor])
    const thresholds = ss.ckmeans(values.filter(v => !isNaN(v)), numberOfColors)
      .map(cluster => cluster[0])
      .map(t => t ? t : 0)
      .concat([dataDomain[1]])
    const colorScale = d3.scaleThreshold()
      .domain(thresholds)
      .range(scheme)*/
    const thresholds = [0,1500,5000,10000,15000,20000,25000,30000];
    const colorScale = d3.scaleThreshold()
      .domain(thresholds)
      .range(scheme)
    const xScale = d3.scaleLinear()//d3.scaleSqrt()//d3.scaleLinear()
      .nice() 
      .domain(d3.extent(colorScale.domain()))
      .rangeRound([0, this.props.width*0.3])
    this.drawLegend(`Average opioid consumption (expressed in S-DDD)`, colorScale, xScale)
    
    var xGridDomain = d3.extent(this.worldTile, d => d.x);
    var yGridDomain = d3.extent(this.worldTile, d => d.y);
    var xWidth = this.props.width/(xGridDomain[1] - xGridDomain[0]);
    var yWidth = this.props.height/(yGridDomain[1] - yGridDomain[0]);
    var squareWidth = Math.min(xWidth, yWidth);
    var xOffset = 0.5 * (this.props.width - ((xGridDomain[1] - xGridDomain[0])*squareWidth))/2;
    var yOffset = (this.props.height - ((yGridDomain[1] - yGridDomain[0])*squareWidth))/2;
    var squarePosition = this.worldTile.reduce( (agg, v) => {
      agg[v.alpha2] = {
        x: (v.x * squareWidth) + xOffset,
        y: (v.y * squareWidth) + yOffset
      }
      return agg;
    }, {})
    var offset  = [
      (this.props.width - scale * (bounds[1][0] + bounds[0][0])) / 2,
      (this.props.height - scale * (bounds[1][1] + bounds[0][1])) / 2
    ];
    // new projection
    projection = d3.geoNaturalEarth1()
      .scale(scale)
      .translate(offset);
    path = path.projection(projection);
    this.squarePosition = squarePosition;
    this.squareWidth = squareWidth;
    this.path = path;
    let self = this;
    this.map
      .selectAll('path')
      .data(this.world.features.map(f => ({...f, value: dataMapping[f.properties.iso_a2]})))
      .enter().append('path')
      .attr('d', path)
      .style('fill', d => d.value ? 
        colorScale(d.value) : '#F0F0F0')
      .style('stroke', 'gray')
      .style('stroke-width', 1)
      .style("cursor", "pointer")
      .on('mouseenter', function(d) { self.updateTooltip(d) })
      .on("mousemove", function(d) { self.moveTooltip(d) })
      .on('mouseleave', function() { self.updateTooltip(null) });
    this.labels
      .selectAll('text')
      .data(this.world.features)
      .enter().append('text')
      .text( d => d.properties.iso_a2 )
      .attr('x', d => this.squarePosition[d.properties.iso_a2].x + (this.squareWidth/2) )
      .attr('y', d => this.squarePosition[d.properties.iso_a2].y + (this.squareWidth/2) )
      .style('fill', 'black')
      .style('alignment-baseline', 'central')
      .style('text-anchor', 'middle')
      .style('font-size', `${Math.round(this.squareWidth * 0.4)}px`)
      .style('font-family', 'Helvetica, Arial, sans-serif')
      .style("pointer-events", "none")
      .style('opacity', 0);
  }
  switchToSquares(){
    this.map
      .selectAll('path')
      .transition()
      .duration(3000)
      .attrTween('d', d => {
          if(this.squarePosition[d.properties.iso_a2]){
            var x = this.squarePosition[d.properties.iso_a2].x;
            var y = this.squarePosition[d.properties.iso_a2].y;
            if(d.geometry.type === 'MultiPolygon'){
              var square = [[x,y], [x+this.squareWidth,y], [x+this.squareWidth,y+this.squareWidth], [x,y+this.squareWidth], [x,y]];
              var filteredPolygons = d.geometry.coordinates.map( coordinates => this.path({type: 'Polygon', coordinates: coordinates}))
                .slice(0,2);
              return flubber.combine(filteredPolygons, square, { single: true });
            } else {
              return flubber.toRect(this.path(d), x, y, this.squareWidth, this.squareWidth, { maxSegmentLength: 10 });
            }
          } else {
            console.log('Unmatched country ' + d.properties.iso_a2);
            return null;
          }
        })
      .transition()
      .duration(0)
      .attr('d', d => {
        if(this.squarePosition[d.properties.iso_a2]){
          var x = this.squarePosition[d.properties.iso_a2].x;
          var y = this.squarePosition[d.properties.iso_a2].y;
          var square = [[x,y], [x+this.squareWidth,y], [x+this.squareWidth,y+this.squareWidth], [x,y+this.squareWidth], [x,y]];
          return flubber.toPathString(square);
        }
      });
    
    this.labels
      .selectAll('text')
      .transition()
      .duration(1000)
      .delay(2000)
      .style('opacity', 1);
  }
  switchToClassic(){
    this.map
      .selectAll('path')
      .transition()
      .duration(3000)
      .attrTween('d', d => {
          if(this.squarePosition[d.properties.iso_a2]){
            var x = this.squarePosition[d.properties.iso_a2].x;
            var y = this.squarePosition[d.properties.iso_a2].y;
            if(d.geometry.type === 'MultiPolygon'){
              var square = [[x,y], [x+this.squareWidth,y], [x+this.squareWidth,y+this.squareWidth], [x,y+this.squareWidth], [x,y]];
              var filteredPolygons = d.geometry.coordinates.map( coordinates => this.path({type: 'Polygon', coordinates: coordinates}))
                .slice(0,2) //needed to add this slice to deal with error acuring on small screen size
              return flubber.separate(square, filteredPolygons, { single: true });
          } else {
              return flubber.fromRect(x, y, this.squareWidth, this.squareWidth, this.path(d), { maxSegmentLength: 10 });
            }
          } else {
            console.log('Unmatched country ' + d.properties.iso_a2);
            return null;
          }
        });
    
    this.labels
      .selectAll('text')
      .transition()
      .duration(300)
      .style('opacity', 0);
  }
  
  drawLegend(title, colorScale, xScale) {
    //const formatNumber = d3.format(".000")

    const xAxis = d3.axisBottom(xScale)
      .tickSize(13)
      //.tickValues(threshold.domain())
      .tickValues(colorScale.range().slice(2).map(d => colorScale.invertExtent(d)[0]))
      //.tickFormat(d => formatNumber(d) )
      .tickFormat(d3.format("~s"))

    this.legend.call(xAxis);

    this.legend.select(".domain").remove();

    this.legend.selectAll("rect")
      .data(colorScale.range().map(function(color) {
        var d = colorScale.invertExtent(color);
        if (d[0] == null) d[0] = xScale.domain()[0];
        if (d[1] == null) d[1] = xScale.domain()[1];
        return d;
      }))
      .enter().insert("rect", ".tick")
        .attr("height", 8)
        .attr("x", function(d) { return xScale(d[0]); })
        .attr("width", function(d) { return xScale(d[1]) - xScale(d[0]); })
        .attr("fill", function(d) { return colorScale(d[0]); })

    this.legend.append("text")
      .attr("fill", "#000")
      .attr("font-weight", "bold")
      .attr("text-anchor", "start")
      .attr("y", -6)
      .text(title)
  }

  updateTooltip(country) {
    if (country) {
      if(this.tooltip) {
        this.tooltip
          .html(`
            <h2 style="margin-block-start: 0; margin-block-end: 0.5em;">${country.properties.name}</h2>
            <div>${country.value ? `${country.value} S-DDD` : 'Unknown consumption'}</div>
          `)
          .style("visibility", "visible");
      }
    } else {
      if(this.tooltip) {
        this.tooltip.style('visibility', 'hidden')
      }
    }
  }
  
  moveTooltip (zone) {
    if(this.tooltip){
      this.tooltip
        .style('width', 0.2 * this.props.width)
        .style('right', d3.event.pageX > this.props.width / 2 ? `calc(100vw - ${d3.event.pageX - 10}px)` : 'auto')
        .style('left', d3.event.pageX <= this.props.width / 2 ? `${d3.event.pageX + 10}px` : 'auto')
        .style('bottom', d3.event.pageY > this.props.height / 2 ? `calc(100vh - ${d3.event.pageY - 10}px)` : 'auto')
        .style('top', d3.event.pageY <= this.props.height / 2 ? `calc(${d3.event.pageY + 10}px)` : 'auto');
    }
  }
}




// WEBPACK FOOTER //
// ./src/components/charts/WorldMap/WorldMap.js